import Mixin from './mixin';
import Logger from './logger';
import Listener from './listener';
import Emitter from './emitter';
import SocketIO from 'socket.io-client';

const version = 3;

export default class VueSocketIO {
  /**
   * lets take all resource
   * @param io
   * @param vuex
   * @param debug
   * @param options
   */
  constructor({connection, vuex, debug, options}) {
    Logger.debug = debug;
    if (connection) {
      this.io = this.connect(connection, options);
    }
    this.emitter = new Emitter(vuex);
    if (this.io) {
      this.listener = new Listener(this.io, this.emitter);
    }
  }

  /**
   * Vue.js entry point
   * @param Vue
   */
  install(Vue) {
    if (version <= +Vue.version.split('.')[0]) {
      Vue.provide('vueSocketIo', this);
      Vue.provide('socket', this.io);
      Vue.config.globalProperties.$socket = this.io;
      Vue.config.globalProperties.$vueSocketIo = this;
    } else {
      Vue.prototype.$socket = this.io;
      Vue.prototype.$vueSocketIo = this;
    }

    Vue.mixin(Mixin);

    Logger.info('Vue-Socket.io plugin enabled');
  }

  /**
   * registering SocketIO instance
   * @param connection
   * @param options
   * NCPHUOC 01/12/2022: Custom theo nhu cầu của dự án
   */
  connect(connection, options) {
    if (connection && typeof connection === 'object') {
      Logger.info('Received socket.io-client instance');
      if (!this.listener) {
        this.listener = new Listener(connection, this.emitter);
      }
      if (!this.io) {
        this.io = connection;
      }
      return connection;
    } else if (typeof connection === 'string') {
      Logger.info('Received connection string');
      this.io = SocketIO(connection, options);
      if (!this.listener) {
        this.listener = new Listener(this.io, this.emitter);
      }
      return this.io;
    } else {
      throw new Error('Unsupported connection type');
    }
  }
}
